import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Plus, X, Trash2 } from "lucide-react";

export default function OwnerTeam() {
  const [team, setTeam] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const load = () => api.get("/app/owner/team").then((r) => setTeam(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Remove this dietitian?")) return;
    try { await api.delete(`/app/owner/team/${id}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
  };

  return (
    <div>
      <div className="section-eyebrow">Team</div>
      <h1 className="mt-1 font-display text-3xl leading-tight" style={{ color: "var(--primary)" }}>Dietitians</h1>
      <button data-testid="new-dietitian" onClick={() => setShowNew(true)} className="btn-primary mt-4 text-sm"><Plus size={14} /> Add dietitian</button>

      <div className="mt-6 space-y-3">
        {team.length === 0 && <div className="card-soft p-6 text-center text-sm" style={{ color: "var(--text-secondary)" }}>No dietitians yet. Add Ankita and your team.</div>}
        {team.map((d) => (
          <div key={d.id} className="card-soft p-4 flex items-center gap-3">
            <div className="w-11 h-11 rounded-full flex items-center justify-center font-bold" style={{ background: "var(--yellow)", color: "var(--primary)" }}>
              {(d.name || "?").slice(0, 2).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold" style={{ color: "var(--primary)" }}>{d.name}</div>
              <div className="text-xs" style={{ color: "var(--text-secondary)" }}>{d.email}</div>
            </div>
            <button onClick={() => del(d.id)} className="text-red-600"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
      {showNew && <NewDietitianModal onClose={() => setShowNew(false)} onCreated={() => { setShowNew(false); load(); }} />}
    </div>
  );
}

function NewDietitianModal({ onClose, onCreated }) {
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/app/owner/team", f);
      toast.success("Dietitian added — share these credentials with them"); onCreated();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.5)" }} onClick={onClose}>
      <div className="w-full max-w-sm card-soft p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-start">
          <div>
            <div className="section-eyebrow">New</div>
            <h3 className="font-display text-2xl mt-1" style={{ color: "var(--primary)" }}>Add dietitian</h3>
          </div>
          <button onClick={onClose}><X /></button>
        </div>
        <form onSubmit={submit} className="mt-4 space-y-3">
          <Input placeholder="Name" value={f.name} onChange={upd("name")} required className="h-11 rounded-xl" />
          <Input placeholder="Email" type="email" value={f.email} onChange={upd("email")} required className="h-11 rounded-xl" />
          <Input placeholder="Password" value={f.password} onChange={upd("password")} required className="h-11 rounded-xl" />
          <button disabled={loading} className="btn-primary w-full disabled:opacity-60">{loading ? "…" : "Create account"}</button>
        </form>
      </div>
    </div>
  );
}
